import App from "./components/App";
import Store from "./services/Store";
import testLocalStorage from "./utils/testLocalStorage";
import initCartFabAttention from "./utils/initCartFabAttention";
import { init as initRating } from "./utils/Rating";
import CookieConsent from "./utils/CookieConsent";

const client = {
  /**
   * Init App component with global store.
   */
  initApp: function () {
    const initialState = {};
    const appStore = Store.create(App.init(initialState), App.update);

    appStore.subscribe(() => {
      App.view(appStore.getState(), appStore.dispatch);
    });

    appStore.dispatch({ type: "INIT" });
  },

  /**
   * Execute immediately without waiting for DOM.
   */
  executeImmediately: function () {
    // replace with empty function, so we don't log errors after unload
    window.onbeforeunload = function () {
      window.onerror = function (message, url, line_number) {};
    };
  },

  initMenuPage: function () {
    if (document.querySelector("[data-cart]") !== null) {
      import(/* webpackChunkName: "MenuPage" */ "./views/MenuPage").then(
        (mod) => mod["default"].init()
      );
    }
  },

  initCheckout: function () {
    if (document.querySelector(".ps-checkout")) {
      import(/* webpackChunkName: "Checkout" */ "./views/Checkout/init").then(
        (checkoutPage) =>
          checkoutPage.init(document.querySelector(".ps-checkout"))
      );
    }
  },

  initOrderInfo: function () {
    if (document.querySelector(".ps-order-info")) {
      import(
        /* webpackChunkName: "ThankYouPage" */ "./views/ThankYouPage/init"
      ).then((thankYouPage) =>
        thankYouPage.init(document.querySelector(".ps-order-info"))
      );
    }
  },

  initReservation: function () {
    if (document.getElementById("ps-reservation")) {
      import(
        /* webpackChunkName: "Reservation" */ "./components/ReservationWrapper"
      ).then((mod) => mod["default"].init());
    }
  },
  initConsents: function () {
    if (document.getElementById("ps-consents")) {
      import(
        /* webpackChunkName: "Consents" */ "./components/ConsentsWrapper"
      ).then((mod) => mod["default"].init());
    }
  },

  /**
   * Init cookie warning
   */
  initCookieConsent: function () {
    CookieConsent.init();
  },

  initDeliveryForm: () => {
    const deliveryModule = document.querySelector(".js-delivery-module");
    if (deliveryModule) {
      import(
        /* webpackChunkName: "DeliveryForm" */ "../../output/Components.DeliveryForm/index.js"
      ).then((mod) =>
        mod.init({
          element: deliveryModule,
          country: Skubacz.configuration.country,
          accountId: Skubacz.configuration.account_id,
          siteId: Skubacz.configuration.site_id,
        })
      );
    }
  },

  initSSR: () => {
    void import("./ssr.js");
  },

  initAgeVerification: function () {
    if (Skubacz.configuration.feature_flags?.enable_age_verification) {
      import(
        /* webpackChunkName: "AgeVerificationModal" */ "./utils/AgeVerification"
      ).then((mod) => mod.init());
    }
  },

  initComponentPreview: function () {
    if (document.getElementById("js-component-preview-container") !== null) {
      import(
        /* webpackChunkName: "ComponentPreview" */ "./views/ComponentPreview/init"
      ).then((mod) => mod.init());
    }
  },
};

client.executeImmediately();

window.Skubacz.Store = Store;

function init() {
  testLocalStorage();
  client.initCookieConsent();
  client.initAgeVerification();
  client.initApp();
  initRating();
  client.initMenuPage();
  client.initCheckout();
  client.initOrderInfo();
  client.initReservation();
  client.initConsents();
  client.initDeliveryForm();
  initCartFabAttention();
  client.initComponentPreview();
  client.initSSR();
}

document.addEventListener("DOMContentLoaded", () => {
  if (window.__pageInitHook__) {
    window.__pageInitHook__().then(init);
  } else {
    init();
  }
});
